import ServiceFactory from "../../../services/factory";

const service = ServiceFactory.get('unity')

export default {
  LIST({commit, dispatch}) {
    commit('app/START_LOADING', null, {root: true})
    return service.list()
      .then((response) => {
        commit('SAVE', response.data)
      }).catch((error) => {
        dispatch('app/HANDLE_API_ERROR', error, {root: true})
        console.log(error)
      }).finally(() => {
        commit('app/STOP_LOADING', null, {root: true})
      })
  },

}
